import React, { useState } from 'react'
 
 
import SalesTargetList from './SalesTargetList';
import SalesTargetForm from './SalesTargetForm';

const SalesTarget= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <SalesTargetForm addForm={setFromIsShown} update={upData} />
        ) : (
          <SalesTargetList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default SalesTarget;